import { createFileRoute } from '@tanstack/react-router';

type Search = {
  locationId?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/schedule/request-history')({
  staticData: { team: 'schedule' },
  validateSearch: (search: Search) => {
    return {
      locationId: search.locationId || undefined,
    };
  },
});
